// src/components/messenger/MessageStatus.tsx

import React from 'react';
import {  AlertIcon, PendingClock, SeenCircle, SentCircle, StatusIconWrapper,  } from '../../styles/messenger/messenger.style';
import { CheckCircle, CheckCircleFill, Clock } from 'react-bootstrap-icons';
import { AlertCircle } from 'lucide-react';

// The component now just takes a simple status prop
interface MessageStatusProps {
  status: 'pending' | 'failed' | 'sent' | 'read';
}

export const MessageStatus: React.FC<MessageStatusProps> = ({ status }) => {
  if (status === 'failed') {
    return (
    //   <StatusIconWrapper>
        <AlertIcon size={16} />
    );
  }

  if (status === 'pending') {
    return (
        <PendingClock size={16}/>
    );
}

  if (status === 'read') {
    return (
        <SeenCircle size={20}/>
    );
  }
  
  return (
    <SentCircle size={16}/>
  );
};